import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import Button from "../../components/CustomButton/CustomButton.jsx";
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; //

const restLink_account = new HttpLink({ 
  uri: "/api/v1/account/",
  credentials: 'include'
 });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

function getUrl($param, $param_1 = null,$param_2 = null) {
  var $url = "/#/"+$param;
  if($param_1 != null) {
    $url += "/"+$param_1;
  }
  if($param_2 != null) {
    $url += "/"+$param_2;
  }
  return $url;
}


const GET_ACCOUNT = gql`
  query getAccounts($search: String!, $limit: Int!, $page: Int!, $order: String!, $orderby: String!){
    account_collection(search: $search, limit: $limit, page: $page, order: $order, orderby: $orderby){
      accounts{
        id,name
      }
    }
  }
`;

const COUNT_ACCOUNTS = gql`query countAccounts($search: String!){
  account_count(search:$search){
    count
  }
}
`;

const DELETE_ACCOUNT = gql`
  mutation deleteAccount($id: Int!){
    deleteAccount(id:$id) {
      id
    }
  }
`;


class AccountList extends Component {

  state = {
    search: '',
    limit: 20,
    page: 1,
    orderby: "id",
    order: "DESC"
  }

  toggleOrder = (event) => {
    this.setState({
      order: (this.state.order == 'DESC'? 'ASC' : 'DESC')
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      search: event.target.elements.search.value,
      order: event.target.elements.order.value,
      orderby: event.target.elements.orderby.value
    });

  }

  render() {
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <NavLink
                  to={'/Account-new/'}
                  className="btn btn-info btn-fill"
                  activeClassName=""
                >
                Nova Conta 
              </NavLink>
              <Card
                title={"Contas criadas"}
                account="Gerenciar contas"
                ctTableFullWidth
                ctTableResponsive
                content={

                  <Table striped hover>
                    <thead>
                      <tr>
                      <th colSpan={9}>
                            <form 
                            onSubmit={e => {
                              this.handleSubmit(e);
                              e.preventDefault();
                            }}
                            >
                              <Row>
                                  <Col md={6} lg={3}>
                                      <input  type="text" name="search" className="form-control" />
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Buscar
                                    </Button>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6} lg={1}>
                                      <select name="orderby" className="form-control">
                                        <option value="id">ID</option>
                                        <option value="name">Nome da Conta</option>
                                      </select>
                                  </Col>
                                  <Col md={6} lg={2}>
                                      <select name="order" className="form-control">
                                        <option value="DESC">Decrescente</option>
                                        <option value="ASC" selected={this.state.order == "ASC"}>Crescente</option>
                                      </select>
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Ordenar
                                    </Button>
                                  </Col>
                                </Row>
                            </form>
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome da Conta</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                        <Query
                          client={account_client}
                          query={GET_ACCOUNT}
                          variables={{
                            search: this.state.search, 
                            limit: this.state.limit, 
                            page: this.state.page, 
                            order: this.state.order, 
                            orderby: this.state.orderby
                          }}
                          fetchPolicy='no-cache'
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <tr><td>Carregando...</td></tr>;
                            if (error) return <tr><td>Erro :(</td></tr>;
                              
                              if(!data.account_collection) {
                                return (<tr><td>(Vazio)</td></tr>);
                              } 

                              return data.account_collection.accounts.map((item) => (
                              
                              <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                
                                <td>
                                  <a className="btn btn-info" href={getUrl('Account-edit',item.id)}>Editar</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('CloudLimitAccount',item.id)}>Limites</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('AccountHasProduct',item.id)}>Produtos Adicionais</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('Combo',item.id)}>Combos</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('CostCustom',item.id)}>Customizar valores</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('User',item.id)}>Usuários</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('subnetsIpam',item.id)}>Subnets IPAM</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('subnetsNutanix',item.id)}>Subnets Nutanix</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('StorageContainerNutanixHasAccount',item.id)}>Storage Container</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('CommClientGroupHasAccount',item.id)}>Commvault</a>
                                </td>
                              </tr>
                            ));
                          }}
                        </Query>
                        <Query
                          client={account_client}
                          query={COUNT_ACCOUNTS}
                          variables={{
                            search: this.state.search
                          }}
                          fetchPolicy='no-cache'
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <tr><td>Carregando...</td></tr>;
                            if (error) return <tr><td>Erro :(</td></tr>;

                              var pagination_buttons = [];
                              var total_pages = data.account_count.count/this.state.limit;
                              for(var page_num = 1; Math.ceil(total_pages) >= page_num; page_num++){
                                pagination_buttons.push(<spam><spam page_num={page_num} className={"btn_page "+(this.state.page==page_num ? 'btn_page_active' : '')} onClick={e => {this.setState({page: e.target.getAttribute('page_num')})}} >{page_num}</spam> </spam>);
                              }
                            return (
                              <tr key={1}>
                                <td colSpan={11}>
                                  {pagination_buttons}
                                </td>
                              </tr>
                            );
                          }}
                        </Query>
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AccountList;
